import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydLabel from '../../../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../../../commonDesign/SydInput'
import SydButton from '../../../../../../../commonDesign/Button'
import SydSwitch from '../../../../../../../commonDesign/SydSwitch'
import generateLocalStorageKey from '../generateLocalStorageKey'

function LocalStorageAndFeatureToggles ({ localConfig, setLocalConfig }) {
  return (
    <Grid item xs={12}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 300px' }}>
          <SydLabel label='Local Storage Key' helperText='Unique key for storing user preferences'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <SydInput
                value={localConfig.localStorageKey || ''}
                onChange={(e) => setLocalConfig(prev => ({
                  ...prev,
                  localStorageKey: e.target.value
                }))}
                placeholder='e.g. my-blueprint.table'
              />
              <SydButton
                size='sm'
                variant='outline'
                onClick={() => setLocalConfig(prev => ({
                  ...prev,
                  localStorageKey: generateLocalStorageKey()
                }))}
                disabled={!!localConfig.localStorageKey}
              >
                Auto
              </SydButton>
              {localConfig.localStorageKey
                ? (
                  <SydButton
                    size='sm'
                    variant='ghost'
                    onClick={() => setLocalConfig(prev => ({
                      ...prev,
                      localStorageKey: ''
                    }))}
                  >
                    Clear
                  </SydButton>
                )
                : null}
            </div>
          </SydLabel>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '18px' }}>
          <SydSwitch
            value={!!localConfig.enableColumnConfig}
            onChange={(e, enabled) => setLocalConfig(prev => ({
              ...prev,
              enableColumnConfig: enabled
            }))}
          />
          <span style={{ fontSize: '0.875rem', whiteSpace: 'nowrap' }}>Enable Column Configuration</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '18px' }}>
          <SydSwitch
            value={!!localConfig.enableSearch}
            onChange={(e, enabled) => setLocalConfig(prev => ({
              ...prev,
              enableSearch: enabled
            }))}
          />
          <span style={{ fontSize: '0.875rem', whiteSpace: 'nowrap' }}>Enable Search</span>
        </div>
      </div>
    </Grid>
  )
}

LocalStorageAndFeatureToggles.propTypes = {
  localConfig: PropTypes.object.isRequired,
  setLocalConfig: PropTypes.func.isRequired
}

export default LocalStorageAndFeatureToggles
